import { gql } from '@apollo/client'

export const CREATE_APP_VERSION = gql`
  mutation CreateAppVersion($input: CreateAndUpdateAppVersionDtoInput!) {
    createAppVersion(input: $input) {
      id
      appIdentifier
      version
      minimumVersion
      forceUpdate
      updateMessage
      platform
    }
  }
`

export const UPDATE_APP_VERSION = gql`
  mutation UpdateAppVersion($input: CreateAndUpdateAppVersionDtoInput!) {
    updateAppVersion(input: $input) {
      id
      appIdentifier
      version
      minimumVersion
      forceUpdate
      updateMessage
      platform
    }
  }
`

export const DELETE_APP_VERSION = gql`
  mutation DeleteAppVersion($id: Long!) {
    deleteAppVersion(id: $id)
  }
`
